import Items, { PropTypes } from '@components/Items'
import bidapi from '../../api/bidapi'
import { GetServerSideProps } from 'next'
import Head from 'next/head'
import { FC } from 'react'
import { buildQueries } from '@components/Items/utils/functions'
import { combineArray } from '@components/Items/utils/hooks/useItems'
import { formatFavLocationUrl } from '../../contexts/NavigationContext/utils'
import getServerSideAccessToken from '@utilities/auth/server/getServerSideAccessToken'
import MainLayout from '@components/MainLayout/MainLayout'

export const getServerSideProps: GetServerSideProps = async (context) => {
  const { query, resolvedUrl } = context
  const baseUrl = `${process.env.NEXT_PUBLIC_AUCTION_API}`
  try {
    const token = await getServerSideAccessToken(context)

    if (token && !query.locations) {
      const userPreferences = await bidapi({
        url: `${baseUrl}/bidder/getFavoriteLocations`,
        context,
        token,
      })
      const userPreferredLocations = Object.keys(userPreferences).map(Number)

      if (userPreferredLocations.length)
        return {
          redirect: {
            destination: formatFavLocationUrl(
              new Set(userPreferredLocations),
              null,
              resolvedUrl
            ),
            permanent: false,
          },
        }
    }

    const data = await bidapi({
      url: `${baseUrl}/search/searchItemList${buildQueries(query as any)}`,
      context,
      token,
    })

    const filterData = await bidapi({
      url: `${baseUrl}/search/searchItemFilters${buildQueries(query as any)}`,
      context,
      token,
    })

    const { items } = await bidapi({
      url: `${baseUrl}/item/getUpdateItemsInfo`,
      context,
      token,
      params: {
        itemIds: data.items?.map(({ id }: { id: number }) => id) || [],
      },
      config: { paramsSerializer: { indexes: null } },
    })

    return {
      props: {
        initialData: {
          ...data,
          items: combineArray(data.items || [], items || []),
        },
        initialFilter: filterData,
      },
    }
  } catch (e) {
    return {
      redirect: {
        destination: '/items?pageId=1',
        permanent: false,
      },
    }
  }
}

const ItemsPage: FC<PropTypes> = (props) => {
  return (
    <MainLayout title="Items">
      <Head>
        <meta name="robots" content="noindex, nofollow" />
      </Head>
      <Items {...props} />
    </MainLayout>
  )
}

export default ItemsPage
